import { observer } from 'mobx-react';
import React from 'react';
import { AnyTask } from '~common/helper/mobx-tasks';
import { Overlay, OverlayProps } from '~web/view/components/layout/overlay.component';

interface Props extends OverlayProps {
  task: AnyTask;
  onErrorClose?: VoidFunction;
}

export const TaskOverlay: React.FunctionComponent<Props> = observer(
  ({ task, onErrorClose, children, ...rest }) => (
    <Overlay error={task.error} onErrorClose={onErrorClose} {...rest}>
      {children}
    </Overlay>
  ),
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/layout/task-overlay.component.tsx